export default __webpack_public_path__ + "locales/sk/Files.json?hash=1c0f651466e2646f878da7dcc1b127aa";